import React, { useMemo, useEffect, useState } from "react";
import ModDrugDiseaseUX from "./ModDrugDiseaseUX";
import { useIntl } from "react-intl";

const ModDrugDisease = (props: any) => {
  const [drugDiseaseReasonOptions, setDrugDiseaseReasonOptions] = useState<any[]>([]);

  const intl = useIntl();

  useEffect(() => {
    const note = props.modDrugDisease?.note || "";
    const options = [
      ...(props.masterOptions?.drugDiseaseReason || []),
      { key: note, text: note, value: note },
    ];
    const arrayUniqueByKey = [
      ...new Map(
        options.flatMap((option) => (option.value ? [[option.value, option]] : []))
      ).values(),
    ];

    setDrugDiseaseReasonOptions(arrayUniqueByKey);
  }, [props.masterOptions?.drugDiseaseReason]);

  const drugLabInteractionList = useMemo(() => {
    return (
      <div style={{ padding: "15px 20px" }}>
        {(props.modDrugDisease?.diseaseItems || []).map((item: any, index: any) => {
          return (
            <div style={{ display: "flex", fontSize: "18px", lineHeight: "2.4rem" }}>
              <div style={{ width: "25px", textAlign: "right", paddingRight: "10px" }}>{`${
                index + 1
              }. `}</div>
              <div style={{ flex: "1", display: "flex", flexDirection: "column" }}>
                <span style={{ color: "red", fontWeight: "bold" }}>{item.drug_name}</span>
                <span style={{ fontWeight: "bold" }}>{intl.formatMessage({id: "โรคประจำตัว"})}{": "}{item.segment_group_name}</span>
                <span style={{ whiteSpace: "pre-wrap" }}>{item.message}</span>
              </div>
            </div>
          );
        })}
      </div>
    );
  }, [props.modDrugDisease?.diseaseItems]);

  const handleAdditionOptions = (e: any, v: any) => {
    setDrugDiseaseReasonOptions([
      ...drugDiseaseReasonOptions,
      { key: v.value, text: v.value, value: v.value },
    ]);
  };

  console.log("ModDrugDisease: ", props, drugLabInteractionList);
  return (
    <ModDrugDiseaseUX
      // data
      drugDiseaseList={drugLabInteractionList}
      orderItemId={
        props.modDrugDisease?.orderItem?.id || props.modDrugDisease?.orderItem?.note_drug_disease
      }
      isEditable={props.isEditable}
      note={props.modDrugDisease?.note}
      drugDiseaseReasonOptions={drugDiseaseReasonOptions}
      // function
      onNoteChange={(e: any, data: any) => {
        props.setProp("modDrugDisease.note", data.value);
      }}
      onApprove={() => {
        if (
          props.modDrugDisease.orderItem?.id ||
          props.modDrugDisease?.orderItem?.note_drug_disease
        ) {
          props.onEvent({
            message: "AddToOrder",
            params: {
              editItem: {
                note_drug_disease: props.modDrugDisease?.note,
              },
              drugIndex: props.modDrugDisease?.orderItem.drugIndex,
              orderType: props.orderType,
              card: "CardDrugOrder",
            },
          });
          props.onEvent({
            message: "HandleModDrugDisease",
            params: { action: "close" },
          });
        } else {
          props.onEvent({
            message: "RunSequence",
            params: {
              sequence: "DrugSelect",
              feedback: "confirm",
              note: props.modDrugDisease?.note,
              orderType: props.orderType
            },
          });
        }
      }}
      onDeny={() => {
        if (
          props.modDrugDisease.orderItem?.id ||
          props.modDrugDisease?.orderItem?.note_drug_disease
        ) {
          props.onEvent({
            message: "HandleModDrugDisease",
            params: { action: "close" },
          });
        } else {
          props.onEvent({
            message: "RunSequence",
            params: { sequence: "DrugSelect", feedback: "cancel" },
          });
        }
      }}
      onAddItem={handleAdditionOptions}
      languageUX={props.languageUX}
    />
  );
};

export default ModDrugDisease;
